export const RequiredUnderline = () => (
  <div role="presentation" className="bg-highlight w-full h-[2px]" />
);
